/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import "./Post.css";
import { Link } from "react-router-dom";
import commentIcon from "../img/comment.svg";
import { format } from "timeago.js";
import Latex from 'react-latex';
function Post({ postId, post, user }) {
  const [comments, setComments] = useState([]);
  const [likes] = useState([]);
  const [comment, setComment] = useState("");
  const [hasMoreComments, setHasMoreComments] = useState(false);
  const [longPost, setlongPost] = useState(false);
  const icon = document.getElementById(postId);
  useEffect(() => {
    document.title = `Accelerator-ত্বারক.tech`;
  }, []);

  useEffect(() => {
    if (postId) {
      db.collection("Posts")
        .doc(postId)
        .collection("Comments")
        .orderBy("timestamp", "asc")
        .onSnapshot((snapshot) => {
          if (snapshot.docs.length > 3) {
            setHasMoreComments(true);
          }
          setComments(
            snapshot.docs
              .slice(Math.max(snapshot.docs.length - 3, 0))
              .map((doc) => doc.data())
          );
        });
    }
  }, [postId]);

  useEffect(() => {
    if(post.description.length > 597) {
      setlongPost(true);
    }
    if (postId && user) {
      db.collection("Posts")
        .doc(postId)
        .collection("Liked_Users")
        .doc(user.id)
        .get()
        .then((s) => {
          try {
            if (s.data().liked) {
              likes.push(postId);
              icon.classList.add("fas");
            }
          } catch (err) {}
        });
        
    }
    
  }, [postId, icon, user, likes, post.description]);

  const changeHeart = () => {
    if (postId && user) {
      icon.classList.toggle("fas");
      if (icon.classList.contains("fas")) {
        db.collection("Posts")
          .doc(postId)
          .collection("Liked_Users")
          .doc(user.id)
          .set({
            liked: true,
          });
        db.collection("Posts")
          .doc(postId)
          .update({
            liked_count: post.liked_count + 1,
          });
      } else {
        db.collection("Posts")
          .doc(postId)
          .update({
            liked_count: post.liked_count - 1,
          });
        db.collection("Posts")
          .doc(postId)
          .collection("Liked_Users")
          .doc(user.id)
          .delete()
          .then(function () {
           
          })
          .catch(function (error) {
            console.error("Error unliking: ", error);
          });
      }
    }
  };
  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const postComment = (event) => {
    event.preventDefault();
    var id = makeid(13);
    db.collection("Posts").doc(postId).collection("Comments").doc(id).set({
      comment: comment,
      commentId: id,
      username: user.name,
      id: user.id,
      post_id: postId,
      image: user.image,
      timestamp: new Date().getTime(),
    });
    setComment("");
  };
  function extractContent(ss) {
    var span = document.createElement("span");
    span.innerHTML = ss;
    try{
    ss = ss.replaceAll("<br>", "\\( \\\\ \\)");
    ss = ss.replaceAll("</p>", "\\( \\\\ \\)");
    ss = ss.replaceAll("</div>", "\\( \\\\ \\)");
    }catch(err){
      return span.textContent 
    }
    span.innerHTML = ss;
    return span.textContent || span.innerText;
  }
  
  return (
    post && (
      <div className="post">
        <div className="postHeader">
          <img className="avatar" src={post.userimage} />
          <ul className="no-bullets">
            <li>
              <div>
                {" "}
                <Link to={`/user/${post.userId}`}>
                  <h3 className="postUsername">{post.username}</h3>
                </Link>
              </div>{" "}
            </li>
            <li>
              {" "}
              <div className="time">{format(post.timestamp)} </div>
            </li>
          </ul>
        </div>
        <div className="postCaption">
          {
            longPost ? (
              <div className="postCaption">
            <Latex>{(extractContent((post.description).substring(0, 600))) }</Latex>
            <Link to={`/post/${postId}`}>
              <p className="postMoreText ">
                see more...
              </p>
         </Link>
         </div>
            ) : (
            <Latex>{(extractContent(post.description)) }</Latex>
            )
          }
        </div>
        

        <Link to={`/post/${postId}`}>
          <img className="postImage" src={post.image_url_0} />
        </Link>
        <div className="postInteractionBar">
           <i onClick={changeHeart} id={postId} className="far fa-heart postInteractionItem postHeart" ></i>
            {post?.liked_count}
          <Link to={`/post/${postId}`}>
          <img src={commentIcon} className="count" height={21}/>
          </Link>
          {post?.comment_count} 
        </div>

        <div className="postComments">
          {comments.map((comment, i) => (
          <dib key={i} className="commentViewC">
              <div className="singlePostRightC">
                <div className="postHeader">
                  <img className="avatar" src={comment.image} />
                  <ul className="no-bullets">
                    <li>
                      <Link className="commentLink" to={`/user/${post.userId}`}>
                        <div className="commentLink">{comment.username}</div>
                      </Link>
                    </li>
                    <li>
                      <div className="time">{format(comment.timestamp)}</div>
                    </li>
                  </ul>
                </div>
                <div className="commentCaption">
                  <Latex>{extractContent(comment.comment)}</Latex>
                </div>
              </div>
            </dib>
          ))}
          <Link to={`/post/${postId}`}>
            {hasMoreComments && (
              <p className="postCaption postMoreComments">
                See all comments ...
              </p>
            )}
          </Link>
        </div>

        {user ? (
          <form className="postCommentsInput">
            <input
              className="postComment"
              type="text"
              placeholder="Add a comment..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <button
              className="postCommentButton"
              type="submit"
              disabled={!comment}
              onClick={postComment}
            >
              {" "}
              Post{" "}
            </button>
          </form>
        ) : (
          ""
        )}
      </div>
    )
  );
}

export default Post;
